// hooks/travelRequest/validateTravelRequest.js

import * as Yup from 'yup';

export const TravelRequestSchema = Yup.object().shape({
    destination: Yup.string().required('Destination is required'),
    type: Yup.string().required('Type is required'),
    start_date: Yup.date().required('Start Date is required'),
    end_date: Yup.date().required('End Date is required'),
    budget_amount: Yup.number().positive('Amount must be positive').required('Spending Budget is required'),
    travellers_count: Yup.number().min(1, 'At least 1 traveller is required').required('Number of Travellers is required'),
    branch_code: Yup.string().required('Branch Code is required'),
    project_code: Yup.string().required('Project Code is required'),
    budget_line: Yup.string().required('Budget Line is required'),
    trip_purpose: Yup.string().required('Trip Purpose is required')
});
